import router from "../router";
import cookie from "@utils/store/cookie";

export default function toLogin(push, backUrl, addMobile) {
  // store.commit("LOGOUT");
  const { fullPath, name } = router.currentRoute;
  if (
    backUrl &&
    backUrl.indexOf("code=") === -1 &&
    fullPath &&
    fullPath.indexOf("code=") === -1
  )
    cookie.set("login_back_url", backUrl || fullPath);
  else cookie.remove("login_back_url");
  if (name === "Login") {
    return;
  }
  if (addMobile) {
    router.push("/user/binding");
    return;
  }
  push ? router.push({ path: "/login" }) : router.replace({ path: "/login" });
}
